import React, { useEffect, useState } from "react";
import { Box, Typography, Table, TableBody, TableCell, TableHead, TableRow, TableContainer as MUITableContainer } from "@mui/material";
import { motion } from "framer-motion";

const generateOrders = (size, c_price) => {
  return Array.from({ length: size }, () => ({
    price: (c_price + Math.random() * 1).toFixed(2),
    amount: (Math.random() * 5).toFixed(4),
  })).sort((a, b) => b.price - a.price);
};

const OrderBookMobile = (props) => {
const {price} = props;
  const [bids, setBids] = useState(generateOrders(10, price));
  const [asks, setAsks] = useState(generateOrders(10, price));

  useEffect(() => {
    const interval = setInterval(() => {
      setBids(generateOrders(10, price));
      setAsks(generateOrders(10, price));
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box>
      

      <Box sx={{  gap: 0, mt: 0, position: "relative", width: "100%" }}>
        <TableContainer title="Asks" data={asks} color="red" direction="left" />
      </Box>

      <Box sx={{  gap: 0, mt: 0, position: "relative", width: "100%" }}>
        <TableContainer title="Bids" data={bids} color="green" direction="left" />
      </Box>
      
    </Box>
  );
};

const TableContainer = ({ title, data, color, direction }) => {
  const maxAmount = Math.max(...data.map((order) => parseFloat(order.amount)));

  return (
    <Box sx={{
      position: "relative",
      overflow: "hidden",
      width: "100%",
      animation: `moveBackground 5s linear infinite`,
      animationDirection: direction === "left" ? "normal" : "reverse",
    }}>
      <Typography variant="subtitle1" sx={{ color }}>{title}</Typography>
      {title === 'Bids' ?


      <MUITableContainer sx={{maxHeight: 'none', border: 'none'}}>
      <Table size="small" sx={{ position: "relative", border: 'none' }}>
        <TableHead>
          <TableRow sx={{ borderBottom: "none" }}>
            <TableCell sx={{borderBottom: "none"}}>Qty</TableCell>
            <TableCell sx={{borderBottom: "none"}}>Price</TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{border: 'none'}}>
          {data.map((order, index) => (
            <motion.tr
              key={index}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              style={{ position: "relative" }}
            >
            <TableCell sx={{borderBottom: "none", fontSize: '11px', padding: '1px'}}>{order.amount}</TableCell>
              <TableCell sx={{ position: "relative", padding: '1px', borderBottom: "none" }}>
                <Box sx={{ position: "relative", fontSize: '11px', color: '#38ba38' }}>
                    {order.price}
                </Box>
              </TableCell>
              
              {title === 'Bids' &&
                  <Box
                  sx={{
                    position: "absolute",
                    right: 0,
                    width: `${(parseFloat(order.amount) / maxAmount) * 100}%`,
                    height: "100%",
                    backgroundColor: color,
                    opacity: 0.2,
                    transition: "width 0.5s ease-in-out",
                  }}
                />

                  }
            </motion.tr>
          ))}
        </TableBody>
      </Table>
    </MUITableContainer>
      :
      <MUITableContainer sx={{maxHeight: 'none', border: 'none'}}>
        <Table size="small" sx={{ position: "relative", border: 'none' }}>
          <TableHead>
            <TableRow  sx={{ borderBottom: "none" }}>
              <TableCell sx={{borderBottom: "none"}}>Price</TableCell>
              <TableCell sx={{borderBottom: "none"}}>Qty</TableCell>
            </TableRow>
          </TableHead>
          <TableBody sx={{border: 'none'}}>
            {data.map((order, index) => (
              <motion.tr
                key={index}
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
                style={{ position: "relative" }}
              >
                <TableCell sx={{ position: "relative", fontSize: '11px', padding: '1px', borderBottom: "none" }}>
                    
                  <Box sx={{ position: "relative", padding: "1px", fontSize: '11px', color: '#f52f2f' }}>{order.price}</Box>
                </TableCell>

                <TableCell sx={{borderBottom: "none", padding: '1px', fontSize: '11px'}}>{order.amount}</TableCell>
                {title === 'Asks' &&
                    <Box
                    sx={{
                    position: "absolute",
                    right: 0,
                    width: `${(parseFloat(order.amount) / maxAmount) * 100}%`,
                    height: "100%",
                    backgroundColor: color,
                    opacity: 0.2,
                    transition: "width 0.5s ease-in-out",
                    }}
                    />}
              </motion.tr>
            ))}
          </TableBody>
        </Table>
      </MUITableContainer>
      }
      
    </Box>
  );
};

export default OrderBookMobile;
